import React, {useEffect, useState} from "react";
import TableVirtualized from "../../../components/virtualized/virtualized";
import Box from '../../../components/box/Box'
import http from "../../../components/plugins/axios";
import Head from "next/head";
import {getBahabinText, getTitleFaIranFinancialMarkets} from "../../../util/DominantUtil";

const GLOBAL_CSS = " text-light"

export default function MarketView() {
    const [data, setData] = useState(null);
    const [rows, setRows] = useState(null);
    const [lastUpdate, setLastUpdate] = useState(null);

    const [sectors] = useState([]);
    const [categoryName, setCategoryName] = useState('همه')


    useEffect(() => {
        callApi()
        return () => {
            // cleanUpAutoScrollIndex()
        }
    }, []);

    useEffect(() => {
        if (rows && rows.length > 0) {
            if (sectors.length === 0) {
                sectors.push('همه');
                for (const index in rows) {
                    sectors.push(rows[index].name);
                }
            }

            showAllRows();
        }
    }, [rows]);

    function callApi() {
        http
            .get("/marketview/persian")
            .then((response) => {
                // return response.data;
                setRows(response.data.data)
                setLastUpdate(response.data.lastUpdate)
            })
            .catch((error) => {
            });
    }

    function cleanUpAutoScrollIndex() {
        // clearInterval(autoScrollIntervalId);
        // dispatch(marketViewsSlice.actions.resetIndex())
    }

    //set background color
    function setBgClassName(value) {
        let digit = Math.round(value);
        digit = digit.toString().length;

        if (typeof value === "number") {
            if (value < 0) {
                switch (true) {
                    case digit === 4:
                        return "negative5" + GLOBAL_CSS;
                    case digit === 3:
                        return "negative4" + GLOBAL_CSS;
                    case digit === 2:
                        return "negative3" + GLOBAL_CSS;
                    case digit === 1:
                        return "negative2" + GLOBAL_CSS;
                    default:
                        return "neutral";
                }
            } else if (value > 0) {
                switch (true) {
                    case digit >= 4:
                        return "positive4" + GLOBAL_CSS;
                    case digit === 3:
                        return "positive3" + GLOBAL_CSS;
                    case digit === 2:
                        return "positive2" + GLOBAL_CSS;
                    case digit === 1:
                        return "positive1" + GLOBAL_CSS;
                    default:
                        return "neutral";
                }
            } else return "zero";
        }
    }

    function dropDownHandler(value) {
        setCategoryName(value)
        if (value === 'همه') showAllRows();
        else {
            const data = rows.filter((x) => x.name === value)[0].data
            setData(data)
        }
    }

    function showAllRows() {
        setData(rows.flatMap(x => x.data))
    }

    function handleSwitchAutoScroll(value) {
        // if (autoScrollIntervalId === null && value != null && rows.length > 10) {
        //     const id = setInterval(() => {
        //         dispatch(marketViewsSlice.actions.updateIndex({counter: scrollToIndex + 1, length: rows.length}));
        //     }, 2000);
        //     dispatch(marketViewsSlice.actions.setAutoScrollIntervalId({autoScrollIntervalId: id}))
        // }

        if (value === false) cleanUpAutoScrollIndex()
    }

    const properties = {
        sectors: sectors,
        dropDownInputPlace: 'گروه',
        dropDownIconClassName: 'fa-industry',
        disableLiveCircle: true,
        switchAutoScroll: true,
        enableAutoScrollButton: true,
        enableAutoScrollBorder: false,
        // handleSwitchAutoScroll: handleSwitchAutoScroll,
        dropDownHandler: dropDownHandler,
        lastUpdate: lastUpdate,
    };

    const tooltipSteps = [
        {
            target: '.extraAutoScroll',
            content: 'پیمایش صفحه به صورت خودکار',
            placement: 'right',
        },
        {
            target: '.extraDropDown',
            content: 'انتخاب گروه یا صنعت',
            placement: 'right',
        },
        {
            target: '.extra-last-update',
            content: 'زمان دقیق به روز رسانی',
            placement: 'right',
        },
    ]

    return (
        <Box uiActions={properties} title={categoryName} loaded={data} tooltipSteps={tooltipSteps} height={930}
             showRW={true}
             linksMap={{
                 'last': 'بازار بورس',
             }}>
            <Head>
                <title>{getTitleFaIranFinancialMarkets('نقشه بازدهی امروز') + getBahabinText()}</title>
            </Head>

            <TableVirtualized
                setBgClassName={x => setBgClassName(x)}
                columns={sourceColumn}
                mutableData={data}
                customHeight={890}
                defaultSortBy={'change1Day'}
                defaultSortDirection={'DESC'}
                keyField="tickerSymbol"
                numberSuffix={'%'}
                // scrollToIndex={scrollToIndex}
            />
        </Box>
    );
};

const sourceColumn = [
    {
        title: "نماد",
        dataIndex: "symbol",
        className: "pr-2",
        type: 'link',
        sorter: true,
        enable: true,
    },
    {
        title: "روز",
        dataIndex: "change1Day",
        sorter: true,
        className: "ltr",
        suffix: '%',
        enable: true,
    },
    {
        title: "هفته",
        dataIndex: "change1Week",
        sorter: true,
        className: "ltr",
        suffix: '%',
        enable: true,
        disableOnMobile: true,
    },
    {
        title: "ماه",
        dataIndex: "change1Month",
        sorter: true,
        className: "ltr",
        suffix: '%',
        enable: true,
        disableOnMobile: true,
    },
    {
        title: "۳ ماه",
        dataIndex: "change3Months",
        sorter: true,
        className: "ltr",
        suffix: '%',
        enable: true,
        disableOnMobile: true,
    },
    {
        title: "۶ ماه",
        dataIndex: "change6Months",
        sorter: true,
        className: "ltr",
        suffix: '%',
        enable: true,
        disableOnMobile: true,
    },
    {
        title: "سال",
        dataIndex: "change1Year",
        sorter: true,
        className: "ltr",
        suffix: '%',
        enable: true,
        disableOnMobile: true,
    },
]

function getFakeData() {
    return Array.from({length: 20}, (_, k) => getJson());
}

function getJson() {
    return {
        "symbol": "-",
        "change1Day": 0,
        "change1Week": 0,
        "change1Month": 0,
        "change3Months": 0,
        "change6Months": 0,
        "change1Year": 0
    }
}